<div class="stk-modal-overlay" (click)="cancel()">
  <div class="stk-modal ec-modal" (click)="stop($event)">
    <div class="stk-modal-kicker">Szállítók</div>
    <h2 class="stk-modal-title">{{ title }}</h2>
    <div class="stk-modal-sub">A szállító neve a címkegenerálásnál és az ország-preferenciáknál jelenik meg.</div>

    <div class="ec-field">
      <label class="stk-label">Szállító neve</label>
      <input type="text" class="stk-input" placeholder="pl. UPS" [(ngModel)]="name" (keydown.enter)="save()">
    </div>

    <div class="ec-field">
      <label class="stk-label">URL</label>
      <input type="text" class="stk-input" placeholder="https://…" [(ngModel)]="url" (keydown.enter)="save()">
    </div>

    <div class="stk-modal-actions">
      <button type="button" class="stk-btn stk-btn--ghost" (click)="cancel()">Mégse</button>
      <button type="button" class="stk-btn stk-btn--dark" [disabled]="!canSave" (click)="save()">Mentés</button>
    </div>
  </div>
</div>
